import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function CommunityFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedCommunity(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedCommunity(null);
  };

  const categories = [
    { id: "all", name: "Todas" },
    { id: "technology", name: "Tecnologia" },
    { id: "gaming", name: "Games" },
    { id: "sports", name: "Esportes" },
    { id: "music", name: "Música" },
    { id: "art", name: "Arte" },
    { id: "education", name: "Educação" },
    { id: "business", name: "Negócios" },
    { id: "lifestyle", name: "Estilo de Vida" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/community?page=${pageNum}&limit=12`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching community:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="community_feed_loading"><div className="community_loader"></div><span>Carregando comunidades...</span></div>;
  }

  return (
    <div className="community_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="community_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
          <h3>Nenhuma comunidade encontrada</h3>
          <p>Crie a primeira!</p>
        </div>
      ) : (
        <div className="community_grid">
          {posts.map((post) => (
            <div key={post._id} className="community_card" onClick={() => setSelectedCommunity(post)}>
              <div className="community_card_cover">
                <img src={post.communityData?.coverImage || post.images?.[0]?.url || "/images/default-community-cover.png"} alt="" />
              </div>
              <div className="community_card_content">
                <div className="community_avatar">
                  <img src={post.communityData?.avatar || post.user.picture} alt="" />
                </div>
                <h3>{post.communityData?.name || post.text}</h3>
                <span className="community_privacy">
                  {post.communityData?.privacy === "private" ? (
                    <>
                      <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"/>
                      </svg>
                      Grupo privado
                    </>
                  ) : (
                    <>
                      <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                      </svg>
                      Grupo público
                    </>
                  )}
                </span>
                <p className="community_description">{post.communityData?.description}</p>
                <div className="community_stats">
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                    </svg>
                    {post.communityData?.memberCount || 0} membros
                  </span>
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                    </svg>
                    {post.communityData?.postsCount || 0} posts
                  </span>
                </div>
                <button className="community_join_btn">Participar</button>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="community_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedCommunity && (
        <div className="community_modal_overlay" onClick={() => setSelectedCommunity(null)}>
          <div className="community_modal" onClick={(e) => e.stopPropagation()}>
            <button className="community_modal_close" onClick={() => setSelectedCommunity(null)}>✕</button>

            <div className="community_modal_cover">
              <img src={selectedCommunity.communityData?.coverImage || selectedCommunity.images?.[0]} alt="" />
              <div className="community_modal_avatar">
                <img src={selectedCommunity.communityData?.avatar || selectedCommunity.user.picture} alt="" />
              </div>
            </div>

            <div className="community_modal_body">
              <div className="community_modal_header">
                <h2>{selectedCommunity.communityData?.name}</h2>
                <span className="community_modal_privacy">
                  {selectedCommunity.communityData?.privacy === "private" ? "Privado" : "Público"}
                </span>
              </div>

              <div className="community_modal_stats">
                <div className="community_modal_stat">
                  <span className="community_modal_stat_value">{selectedCommunity.communityData?.memberCount || 0}</span>
                  <span className="community_modal_stat_label">membros</span>
                </div>
                <div className="community_modal_stat">
                  <span className="community_modal_stat_value">{selectedCommunity.communityData?.postsCount || 0}</span>
                  <span className="community_modal_stat_label">publicações</span>
                </div>
                <div className="community_modal_stat">
                  <span className="community_modal_stat_value">{selectedCommunity.communityData?.admins?.length || 1}</span>
                  <span className="community_modal_stat_label">admins</span>
                </div>
              </div>

              <div className="community_modal_section">
                <h4>Sobre</h4>
                <p>{selectedCommunity.communityData?.description || selectedCommunity.text}</p>
              </div>

              <div className="community_modal_section">
                <h4>Categoria</h4>
                <span className="community_modal_category">
                  {categories.find(c => c.id === selectedCommunity.communityData?.category)?.name || "Geral"}
                </span>
              </div>

              {selectedCommunity.communityData?.rules?.length > 0 && (
                <div className="community_modal_section">
                  <h4>Regras da comunidade</h4>
                  <ol className="community_rules_list">
                    {selectedCommunity.communityData.rules.map((rule, i) => (
                      <li key={i}>{rule}</li>
                    ))}
                  </ol>
                </div>
              )}

              {selectedCommunity.communityData?.admins?.length > 0 && (
                <div className="community_modal_section">
                  <h4>Administradores</h4>
                  <div className="community_admins_list">
                    {selectedCommunity.communityData.admins.map((admin, i) => (
                      <div key={i} className="community_admin_item">
                        <img src={admin.picture || "/images/default-avatar.png"} alt="" />
                        <span>{admin.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <Link to={`/profile/${selectedCommunity.user.username}`} className="community_creator">
                <img src={selectedCommunity.user.picture} alt="" />
                <div>
                  <span className="community_creator_label">Criador</span>
                  <span className="community_creator_name">{selectedCommunity.user.first_name} {selectedCommunity.user.last_name}</span>
                </div>
              </Link>

              <button className="community_modal_join_btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                Participar da comunidade
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
